export default {
  allMsg: 'Todas as mensagens',
  systemMsg: 'Mensagem do sistema',
  personMsg: 'Mensagem pessoal',
  unread: 'Não lido',
  seeDetail: 'Ver detalhes',
  read: 'Lido',
  replyNow: 'Responder agora',
  message: 'Mensagem interna',
  operateSuccess: 'Operação bem-sucedida',
  holder: {
    searchHolder: 'Número do pacote/Número do pedido/Número do produto',
  },
  addAcBuy: 'Junte-se ao AcBuy Discord e ganhe prêmio em dinheiro de ¥2000!',
  joinNow: 'Clique aqui para se juntar',
  flatActivity: 'Promoção Black Friday Acbuy',
  joinNow1: 'Juntar-se agora',
  tips1: 'Desfrute de até 70% de desconto',
  tips2: 'Digite o código para receber imediatamente cupom de frete de ¥110!',
}
